import type { SavedPaymentMethod } from './types'
import useTranslation from 'hooks/useTranslation'
import React from 'react'

interface PaymentMethodBadgesProps {
  method: Pick<SavedPaymentMethod, 'isDefault' | 'status'>
  showDefault?: boolean
}

const PaymentMethodBadges: React.FC<PaymentMethodBadgesProps> = ({ method, showDefault = true }) => {
  const { t } = useTranslation('account')
  const inactive = method.status && method.status !== 'active'
  if (!(showDefault && method.isDefault) && !inactive) return null

  return (
    <span className='pmBadges'>
      {showDefault && method.isDefault && <span className='pmBadge --default'>{t('defaultMethod')}</span>}
      {inactive && <span className={`pmBadge ${method.status === 'revoked' ? '--muted' : '--danger'}`}>
        {t(`savedMethodStatuses.${method.status}`)}
      </span>}
    </span>
  )
}

export default PaymentMethodBadges
